import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { RxCross2 } from 'react-icons/rx';
import { Minus, Plus } from 'lucide-react';
import { FaArrowLeft, FaCaretRight } from 'react-icons/fa';
import { TbPercentage } from 'react-icons/tb';
import { RiDeleteBin6Line } from 'react-icons/ri';
import CouponPage from './CouponPage';
import EmptyCartModal from './EmptyCartModal';
import Namsteji_Manikchand_Icon from '../../../../../assets/images/Namsteji_Manikchand_Icon.svg';
import config from '../../../../../config/environment';

const ProductCartMobilePage: React.FC<any> = ({
  cartDataArr,
  emptyCart,
  cartItemPlusMinus,
  inputCode,
  handleApply,
  listOfCoupen,
  showCoupenModalMobile,
  setShowCoupenModalMobile,
  showNullDivNotProduct,
  appliedCouponName,
  handleRemoveCoupon,
}) => {
  const navigate = useNavigate();
  const serverUrl = config.SERVER_URL;
  const itemsArr = cartDataArr?.items ?? [];

  return (
    <>
      {/* Mobile veiw md& sm */}
      {/* {!showNullDivNotProduct && ( */}
      <div className='block sm:block md:block lg:hidden'>
        <div className='flex-1 overflow-y-auto py-3 px-6 flex flex-col gap-2'>
          <div className='flex flex-row items-center gap-1'>
            <button className='flex flex-row items-center text-xl gap-2'>
              <FaArrowLeft onClick={() => navigate(-1)} className='w-[16px] h-[16px]' />
              <span className='font-semibold font-rubik text-base'>Cart</span>
            </button>
          </div>

          {!showNullDivNotProduct && (
            <>
              <div className='flex justify-between place-items-end py-1'>
                <Link to='/products'>
                  <button className='text-sm text-[#442a10] border-b border-[#442a10] font-poppins'>Add More</button>
                </Link>
                <button
                  className='text-sm text-[#442a10] border-b border-[#442a10] font-poppins'
                  onClick={() => emptyCart()}
                >
                  Empty Cart
                </button>
              </div>

              <div className='bg-white rounded-xl shadow-md space-y-3'>
                {itemsArr &&
                  itemsArr.length > 0 &&
                  itemsArr.map((item: any, index: number) => {
                    const isDisabled = !item.tax_amount;
                    return (
                      <div
                        key={`${item.item_code}-${index}`}
                        className={`border-b border-gray-200 ${isDisabled ? 'opacity-80 pointer-events-none select-none' : ''}`}
                      >
                        <div className='flex justify-between gap-3 p-3'>
                          {/* Product Image */}
                          <img
                            src={
                              item.web_item_name?.thumbnail
                                ? serverUrl + item.web_item_name.thumbnail
                                : Namsteji_Manikchand_Icon
                            }
                            className='w-[68px] h-[80px] md:w-[120px] md:h-[120px] object-cover rounded'
                          />
                          {/* Item Details */}
                          <div className='flex flex-col flex-1 gap-2'>
                            <h3 className='text-sm sm:text-sm md:text-base text-[#1A1A1A] font-poppins'>
                              {item.web_item_name?.web_item_name}
                            </h3>
                            <p className='text-xs sm:text-xs md:text-sm text-orange-900 flex items-center font-poppins'>
                              {item.qty} <RxCross2 className='w-4 h-4' />{' '}
                              {item.website_item ? item.website_item.toFixed(2) : ''}
                              <span className='text-xs sm:text-xs md:text-sm pl-1 text-[#9E9E9E] font-poppins'>
                                {item.uom_conversion?.conversion_factor
                                  ? 'Pack of ' + item.uom_conversion.conversion_factor
                                  : ''}
                              </span>
                            </p>
                            {/* Quantity controls */}
                            <div className='flex items-center justify-between border border-[#C12E2A] rounded-lg px-2 py-[1px] max-w-[6rem]'>
                              <button
                                onClick={() =>
                                  !isDisabled &&
                                  cartItemPlusMinus(
                                    // Math.max(1, item.qty - 1),
                                    item.qty - 1,
                                    item.item_code,
                                    'plus'
                                  )
                                }
                                disabled={isDisabled}
                              >
                                <Minus className='text-red-700' size={16} />
                              </button>
                              <span className='font-medium'>{item.qty}</span>
                              <button
                                onClick={() => cartItemPlusMinus(item.qty + 1, item.item_code, 'plus')}
                                disabled={isDisabled}
                              >
                                <Plus className='text-red-700' size={16} />
                              </button>
                            </div>
                          </div>

                          {/* Remove + Price */}
                          <div className='flex flex-col justify-between'>
                            <div className='flex justify-center'>
                              <button
                                onClick={() => !isDisabled && cartItemPlusMinus(0, item.item_code, 'plus')}
                                disabled={isDisabled}
                              >
                                <RiDeleteBin6Line className='text-[#9E9E9E]' size={22} />
                              </button>
                            </div>
                            <div className='mt-1 text-bottom'>
                              <p className='font-semibold text-black font-poppins'>
                                ₹ {item.tax_amount ? item.tax_amount.toFixed(0) : '00.00'}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
              {listOfCoupen.current && listOfCoupen.current.length > 0 && (
                <div
                  className='flex items-center justify-center gap-2 py-3 rounded-xl shadow-md border mt-3 cursor-pointer bg-white'
                  onClick={() => setShowCoupenModalMobile(true)}
                >
                  <div className='w-6 h-6 flex items-center justify-center rounded-full bg-[#552B18]'>
                    <TbPercentage className='w-4 h-4 text-white' />
                  </div>
                  <span className='font-medium font-poppins'>See all offers</span>
                  <FaCaretRight className='w-4 h-4 text-[#552B18] ' />
                </div>
              )}
              <div className='p-4 bg-white rounded-lg shadow-md gap-2 mt-3'>
                <h2 className='text-lg font-semibold mb-4 font-poppins'>Cart Total</h2>
                <div className='text-sm sm:text-sm md:text-base text-[#9E9E9E]'>
                  <div className='flex justify-between mb-2'>
                    <span className='font-poppins'>Subtotal</span>
                    <span className='font-poppins'>₹ {cartDataArr?.net_total?.toFixed(2)}</span>
                  </div>
                  <div className='flex justify-between mb-2'>
                    <span className='font-poppins'>
                      Discount{' '}
                      {cartDataArr?.additional_discount_percentage
                        ? '(' + cartDataArr?.additional_discount_percentage + ') % OFF'
                        : ''}
                    </span>
                    <span className='font-poppins'>
                      ₹ {cartDataArr?.discount_amount ? cartDataArr.discount_amount.toFixed(2) : '0.00'}
                    </span>
                  </div>
                  <div className='flex justify-between mb-2'>
                    <span className='font-poppins'>Effective subtotal</span>
                    <span className='font-poppins'>
                      ₹ {cartDataArr?.discount_amount ? cartDataArr.discount_amount.toFixed(2) : '0.00'}
                    </span>
                  </div>
                  <div className='flex justify-between mb-2'>
                    <span className='font-poppins'>GST</span>
                    <span className='font-poppins'>₹ {cartDataArr?.tax_amount?.toFixed(2)}</span>
                  </div>
                  <div className='flex justify-between mb-2'>
                    <span className='font-poppins'>Shipping</span>
                    <span className='text-green-600 font-poppins'>Free</span>
                  </div>
                  <hr className='my-2 border-gray-300' />
                  <div className='flex justify-between text-base font-semibold mb-4 font-poppins'>
                    <span className='font-poppins'>Grand Total</span>
                    <span className='font-poppins'>
                      ₹ {cartDataArr?.grand_total ? cartDataArr?.grand_total?.toFixed(2) : '0.00'}
                    </span>
                  </div>
                </div>
                <Link to='/product/billing-info'>
                  <button className='text-white text-lg font-semibold py-2 px-4 rounded-md w-full bg-[#C12E2A] hover:bg-[#a02823ff] font-poppins'>
                    Proceed to Checkout
                  </button>
                </Link>
              </div>
            </>
          )}
        </div>
        {/* </div> */}

        {!showNullDivNotProduct && showCoupenModalMobile && (
          <div tabIndex={-1} className='fixed top-0 left-0 right-0 z-50 w-full overflow-x- overflow-y-auto '>
            <div className='relative bg-white rounded-lg shadow-sm dark:bg-gray-700 min-h-[100vh]'>
              <div className='flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200'>
                <div></div>
                <div className='text-xl font-bold font-rubik text-[#552B18]'>Coupon Code</div>
                <button
                  type='button'
                  className='bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg'
                  onClick={() => setShowCoupenModalMobile(false)}
                >
                  <RxCross2 className='text-xl text-[#552B18]' />
                </button>
              </div>
              <CouponPage
                inputCode={inputCode}
                handleApply={handleApply}
                listOfCoupen={listOfCoupen}
                appliedCouponName={appliedCouponName}
                handleRemoveCoupon={handleRemoveCoupon}
              />
            </div>
          </div>
        )}

        {showNullDivNotProduct && <EmptyCartModal />}
      </div>
    </>
  );
};

export default ProductCartMobilePage;
